import { Button } from "@mui/material";
import { useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { http } from "src/api/http";
import DeleteUserConfirmationDialog from "./DeleteUserConfirmationDialog";
import { ArelTooltip } from "@arelia-components/ui-atoms/Tooltip";

type Props = {
  identityId: string;
  disabled?: boolean;
}

export default function DeleteUser({ identityId, disabled }: Props) {
  const [dialogOpened, setDialogOpened] = useState(false);
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { mutate, isLoading } = useMutation({
    mutationFn: () => http(`/api/admin/user/${identityId}`, {
      method: 'DELETE',
    }),
    onSuccess: () => {
      queryClient.invalidateQueries(['useHqCustomerDetails']);
      navigate("/hq/customers");
    }
  });

  const handleDeleteConfirm = (isConfirmed: boolean) => {
    if (isConfirmed) {
      mutate();
    }
    setDialogOpened(false);
  }

  const tooltipTitle = disabled ? "You can delete only closed accounts" : "";

  return <>
    <ArelTooltip title={tooltipTitle}>
      <span style={{ display: "flex" }}>
        <Button
          size="large"
          variant="contained"
          color="error"
          onClick={() => setDialogOpened(true)}
          disabled={isLoading || disabled}
          sx={styles.button}
        >
          Delete
        </Button>
      </span>
    </ArelTooltip>

    {dialogOpened &&
      <DeleteUserConfirmationDialog onClose={handleDeleteConfirm} />
    }
  </>;
}

const styles = {
  button: {
    ml: 2
  }
};
